import styled from 'styled-components';
import { MEDIA_QUERY, Stack, Typography } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { FONT_SIZE_1000, FONT_SIZE_900 } from '../../capitalThemeConstants';
import { LocalizedCurrencyValueInteger } from '../../components/LocalizedCurrencyValueInteger';

const LocalizedCurrencyValueIntegerStyled = styled(LocalizedCurrencyValueInteger)`
    font-size: ${FONT_SIZE_1000};

    ${MEDIA_QUERY.tabletMax} {
        font-size: ${FONT_SIZE_900};
    }
`;

interface AvailableFundingProps {
    value: number;
}

export const AvailableFunding: React.FC<AvailableFundingProps> = ({ value }) => (
    <Stack vertical spacing="100">
        <Typography textStyle="bodyMediumStrong" as="div">
            <LocalizedText textKey={TextKey.FinancialServicesCapitalAvailableFunding} />
            {UnicodeEntity.Asterisk}
        </Typography>
        <LocalizedCurrencyValueIntegerStyled value={value} />
    </Stack>
);
